import { IGazeAdapter, GazePoint } from "../adapters/IGazeAdapter";
import { GazeCursor } from "../entities/GazeCursor";

export class GazeSystem {
  private adapter: IGazeAdapter;
  private cursor: GazeCursor;

  constructor(adapter: IGazeAdapter, cursor: GazeCursor) {
    this.adapter = adapter;
    this.cursor = cursor;
  }

  start(): void {
    this.adapter.start();
  }

  stop(): void {
    this.adapter.stop();
  }

  update(): GazePoint {
    const gaze = this.adapter.getGazePoint();
    this.cursor.update(gaze.x, gaze.y);
    return gaze;
  }

  destroy(): void {
    this.stop();
    this.cursor.destroy();
  }
}
